import { Check, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { SITE, waLink } from "../config/site";

const INCLUDED = [
  "50-minute one-to-one session (online or in-person)",
  "A therapy plan tailored to you — play for kids, CBT & client-centred work for adults",
  "Parent guidance notes after child sessions",
  "WhatsApp check-ins between sessions",
];

export default function Pricing() {
  return (
    <section id="pricing" data-testid="pricing-section" className="grain relative overflow-hidden bg-[#022C22] py-20 lg:py-28">
      <div className="pointer-events-none absolute -top-32 right-0 h-96 w-96 rounded-full bg-[#064E3B]/60 blur-3xl" />
      <div className="relative z-[2] mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-4 sm:px-8 lg:grid-cols-12 lg:px-16">
        <Reveal className="lg:col-span-6">
          <Eyebrow dark>Pricing &amp; transparency</Eyebrow>
          <h2 className="mt-4 font-serif text-3xl font-medium leading-snug tracking-tight text-[#FDFBF7] sm:text-4xl lg:text-5xl">
            Honest pricing, because therapy shouldn&rsquo;t start with a <em className="text-[#A7F3D0]">mystery</em>
          </h2>
          <p className="mt-5 max-w-lg text-base leading-relaxed text-[#FDFBF7]/70">
            You&rsquo;ll always know what a session costs before you book. A limited number of
            sliding-scale slots are kept aside for families who need them — just ask.
          </p>
          <ul className="mt-8 space-y-3.5">
            {INCLUDED.map((item) => (
              <li key={item} className="flex items-start gap-3 text-sm text-[#FDFBF7]/85">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#A7F3D0]/15 text-[#A7F3D0]">
                  <Check size={12} strokeWidth={3} />
                </span>
                {item}
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-6">
          <div className="relative rounded-[2rem] bg-[#FDFBF7] p-8 shadow-[0_40px_80px_-40px_rgba(0,0,0,0.6)] sm:p-10">
            <span
              data-testid="pricing-starting-from-badge"
              className="absolute -top-4 left-8 rounded-full bg-[#D97706] px-4 py-1.5 text-xs font-bold uppercase tracking-[0.15em] text-[#FDFBF7]"
            >
              Starting from
            </span>
            <div className="flex items-end gap-2">
              <span className="font-serif text-6xl font-semibold tracking-tight text-[#064E3B] sm:text-7xl">
                {SITE.price}
              </span>
              <span className="pb-2 text-sm text-[#526560]">/ session</span>
            </div>
            <p className="mt-3 text-sm text-[#526560]">
              {SITE.sessionLength} &middot; online or in-person &middot; first 15-min discovery call is free
            </p>
            <p data-testid="pricing-availability" className="mt-2 flex items-center gap-1.5 text-xs font-semibold text-[#059669]">
              Available: {SITE.availability}
            </p>
            <div className="my-7 h-px bg-[#064E3B]/10" />
            <div className="flex flex-wrap gap-3">
              <a
                href="#book"
                data-testid="pricing-book-now-button"
                className="group flex items-center gap-2 rounded-full bg-[#064E3B] px-6 py-3.5 text-sm font-semibold text-[#FDFBF7] transition-all duration-300 hover:bg-[#022C22] hover:shadow-[0_14px_36px_-12px_rgba(6,78,59,0.55)]"
              >
                Book your session
                <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
              <a
                href={waLink}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="pricing-whatsapp-button"
                className="flex items-center gap-2 rounded-full border border-[#064E3B]/25 px-6 py-3.5 text-sm font-semibold text-[#064E3B] transition-colors duration-300 hover:bg-[#ECFDF5]"
              >
                Ask on WhatsApp
              </a>
            </div>
            <p className="mt-5 text-xs text-[#526560]">
              Fees shared transparently on enquiry for couple &amp; family formats.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
